/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Getting_TranscriptsInputs */



/**
* | output |
* | --- |
* | "Error getting transcripts" |
*
* @param {Error_Getting_TranscriptsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_getting_transcripts = /** @type {((inputs?: Error_Getting_TranscriptsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Getting_TranscriptsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Erreur lors de la récupération des transcriptions")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fehler beim Abrufen der Transkripte")
	if (locale === "it") return /** @type {LocalizedString} */ ("Errore durante il recupero delle trascrizioni")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ошибка при получении стенограмм.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al obtener las transcripciones")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("获取成绩单时出错")
	if (locale === "ja") return /** @type {LocalizedString} */ ("トランスクリプトの取得中にエラーが発生しました")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्रतिलेख प्राप्त करने में त्रुटि")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Erro ao obter transcrições")
	return /** @type {LocalizedString} */ ("Error getting transcripts")
});